import { userConstants } from "../../constant";

const initialState = {
  data: null,
  loading: false,
};

export const sellerVacation = (state = initialState, action) => {
  switch (action.type) {
    case userConstants.GET_SELLER_VACATION:
      return { ...state, data: action.payload, loading: false };
    case userConstants.UPDATE_SELLER_VACATION:
      return { ...state, data: action.payload, loading: false };
    default:
      return state;
  }
};
